export default __webpack_public_path__ + "static/media/blank_chapters.1e5bbb71.svg";